/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentEditorCouponViewModel } from "../types/IndividualPaymentEditorCouponViewModel.ts";

export const individualPaymentEditorCouponViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  description: z.string().nullish(),
  discountPercentage: z.number().nullish(),
  discountValue: z.number().nullish(),
}) as unknown as ToZod<IndividualPaymentEditorCouponViewModel>;
